export function slugifyProblemName(name = '') {
  return name
    .toLowerCase()
    .replace(/\([^)]*\)/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

export function titleFromSlug(slug = '') {
  return slug
    .split('-')
    .filter(Boolean)
    .map((word) => {
      if (word === 'ii' || word === 'iii' || word === 'iv') return word.toUpperCase();
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(' ');
}

export function internalProblemPathFromName(name) {
  return `/problems/${slugifyProblemName(name)}`;
}

export function internalProblemPathFromLeetcodeUrl(url, fallbackName) {
  if (!url) return fallbackName ? internalProblemPathFromName(fallbackName) : '/problems';

  const problemMatch = url.match(/leetcode\.com\/problems\/([^/?#]+)/i);
  if (problemMatch) return `/problems/${problemMatch[1].replace(/\/$/, '')}`;

  const tagMatch = url.match(/leetcode\.com\/tag\/([^/?#]+)/i);
  if (tagMatch) return `/problems?topic=${tagMatch[1].replace(/-/g, '+')}`;

  return url;
}

export function isInternalRoute(path = '') {
  return path.startsWith('/');
}
